document.addEventListener("DOMContentLoaded", function () {
    var bladeData = document.getElementById("blade-data");
    if (
        bladeData &&
        bladeData.getAttribute("data-page-type") === "article-show"
    ) {
        /*Annotator plugin*/
        // if (bladeData.getAttribute("data-is-auth") === "true") {
        //     var pageUri = function () {
        //         return {
        //             beforeAnnotationCreated: function (ann) {
        //                 ann.uri = window.location.href;
        //             },
        //         };
        //     };
        
        //     function addUserToUI(viewer) {
        //         viewer.addField({
        //             load: function (field, annotation) {
        
        //                 field = $(field).closest('.annotator-annotation.annotator-item');
        
        //                 if (annotation.user_name) {
        //                     var names = annotation.user_name.split(" ");
        //                     var formattedName = names[0];
        //                     if (names.length > 1) {
        //                         formattedName += " " + names[1].charAt(0) + ".";
        //                     }
        
        //                     var createdAt = new Date(annotation.created_at);
        //                     var formattedDate = createdAt.toLocaleDateString('en-US', {
        //                         year: 'numeric',
        //                         month: 'short',
        //                         day: 'numeric'
        //                     });
        
        //                     var annotationInfo = '<span class="user-annotation">' +
        //                         formattedName +
        //                         '</span> (<span class="date-annotation">on ' + formattedDate + '</span>):';
        
        //                     var annotationInfoDiv = field.find('.annotation-info');
        //                     if (annotationInfoDiv.length === 0) {
        //                         annotationInfoDiv = $('<div class="annotation-info"></div>');
        //                         var contentDiv = field.children('div').first();
        //                         if (contentDiv.length > 0) {
        //                             contentDiv.before(annotationInfoDiv);
        //                         }
        //                     }
        
        //                     annotationInfoDiv.html(annotationInfo);
        
        //                     field.children('div').each(function() {
        //                         if ($(this).html().trim() === '') {
        //                             $(this).remove();
        //                         }
        //                     });
        
        //                 } else {
        //                     field.remove();
        //                 }
        //             },
        //         });
        //     }
        
        //     var textElement = document.getElementById("text");
        //     var app = new annotator.App();
        
        //     app.include(annotator.ui.main, {
        //         element: textElement,
        //         viewerExtensions: [addUserToUI],
        //     });
        
        //     app.include(pageUri);
        //     app.include(annotator.storage.http, {
        //         headers: {
        //             "X-CSRF-TOKEN": window.CSRF_TOKEN, // Use the global variable here
        //         },
        //         urls: {
        //             create: "/annotation",
        //             update: "/annotation/{id}",
        //             destroy: "/annotation/{id}",
        //             search: "/search",
        //         },
        //     });
        
        //     app.start().then(function () {                
        //         app.annotations.load({
        //             uri: window.location.href,
        //         }).then(function () {
        //             //console.log('');
        //         });
        //     });
        // }
        
        function hasAncestorWithClass(element, className) {
            while (element) {
                if (
                    element.classList &&
                    element.classList.contains(className)
                ) {
                    return true;
                }
                element = element.parentElement;
            }
            return false;
        }
        
        function hasAncestorWithId(element, id) {
            while (element) {
                if (element.id === id) {
                    return true;
                }
                element = element.parentElement;
            }
            return false;
        }

        function isInsideTextDiv(element) {
            while (element) {
                if (element.id === "text") {
                    return true;
                }
                element = element.parentElement;
            }
            return false;
        }
        
        document.addEventListener("copy", function (e) {
            if (!isInsideTextDiv(e.target) || 
                hasAncestorWithClass(e.target, "annotator-editor") || 
                hasAncestorWithId(e.target, "comments-div")) {
                return; 
            }
            
            e.preventDefault();
            //alert("Copying text has been disabled on this site.");
        });

        document.addEventListener("cut", function (e) {
            
            if (!isInsideTextDiv(e.target) || 
                hasAncestorWithClass(e.target, "annotator-editor") || 
                hasAncestorWithId(e.target, "comments-div")) {
                return; 
            }
            
            e.preventDefault();
        });

        if (
            bladeData.getAttribute("data-article-type-box") &&
            bladeData.getAttribute("data-people-maturity") &&
            bladeData.getAttribute("data-operations-maturity") &&
            bladeData.getAttribute("data-technology-maturity") &&
            bladeData.getAttribute("data-data-maturity") &&
            document.getElementById("svg-container")
        ) {
            function drawRatingBox(type, maturityString, maturityMessage) {

                const translations = {
                    "en": {
                        categories: ['People', 'Operations', 'Technology', 'Data'],
                        type: 'Type:'
                    },
                    "es": {
                        categories: ['Personas', 'Operaciones', 'Tecnología', 'Datos'],
                        type: 'Tipo:'
                    },
                    "pt-BR": {
                        categories: ['Pessoas', 'Operações', 'Tecnologia', 'Dados'],
                        type: 'Tipo:'
                    }
                };
                
                const categories = translations[currentLanguage].categories;
                const typeText = translations[currentLanguage].type;
                const levels = maturityString
                    .split("-")
                    .map((s) => parseInt(s.slice(1)));

                let svg = `<svg id="boxPopover" cursor="pointer" width="132" height="100" data-bs-toggle="popover" data-bs-content="${maturityMessage}">
            <rect x="0" y="0" rx="4" ry="4" width="132" height="100" style="fill:#ffff;stroke:#dedede;stroke-width:3.4;" />
            <text x="6" y="13">${typeText}</text>
            <text x="60" y="13" style="font-size: 11px; font-weight:bolder; fill:#6389a2">${type}</text>`;

                const infoIconX = 115;
                const infoIconY = 4;
                svg += `<svg x="${infoIconX}" y="${infoIconY}" width="12" height="12" viewBox="0 0 512 512">
                <g id="SVGRepo_iconCarrier">
                    <style type="text/css">
                        .st0{fill:#3d3d3d;}
                    </style>
                    <g>
                        <path class="st0" d="M290.671,135.434c37.324-3.263,64.949-36.175,61.663-73.498c-3.241-37.324-36.152-64.938-73.476-61.675 c-37.324,3.264-64.949,36.164-61.686,73.488C220.437,111.096,253.348,138.698,290.671,135.434z"/>
                        <path class="st0" d="M311.31,406.354c-16.134,5.906-43.322,22.546-43.322,22.546s20.615-95.297,21.466-99.446 c8.71-41.829,33.463-100.86-0.069-136.747c-23.35-24.936-53.366-18.225-79.819,7.079c-17.467,16.696-26.729,27.372-42.908,45.322 c-6.55,7.273-9.032,14.065-5.93,24.717c3.332,11.515,16.8,17.226,28.705,12.871c16.134-5.895,43.3-22.534,43.3-22.534 s-12.595,57.997-18.869,87c-0.874,4.137-36.06,113.292-2.505,149.18c23.35,24.949,53.343,18.226,79.819-7.066 c17.467-16.698,26.729-27.373,42.908-45.334c6.55-7.263,9.009-14.054,5.93-24.706C336.66,407.733,323.215,402.01,311.31,406.354z"/>
                    </g>
                </g>
            </svg>`;

                for (let i = 0; i < categories.length; i++) {
                    const y = 30 + i * 18;
                    svg += `<text x="6" y="${y}">${categories[i]}:</text>`;
                    for (let j = 0; j < 4; j++) {
                        const x = 60 + j * 17;
                        const fill = j < levels[i] ? "#6389a2" : "#dedede";
                        svg += `<rect x="${x}" y="${
                            y - 8
                        }" width="15" height="15" fill="${fill}"></rect>`;
                    }
                }

                document.getElementById("svg-container").innerHTML = svg;
            }

            drawRatingBox(
                bladeData.getAttribute("data-article-type-box"),
                "P" +
                    bladeData.getAttribute("data-people-maturity") +
                    "-O" +
                    bladeData.getAttribute("data-operations-maturity") +
                    "-T" +
                    bladeData.getAttribute("data-technology-maturity") +
                    "-D" +
                    bladeData.getAttribute("data-data-maturity"),
                bladeData.getAttribute("data-maturity-message")
            );
        }
    }

    function updateSvgContainerClass() {
        var h1Element = document.querySelector("h1");
        var svgContainer = document.getElementById("svg-container");

        if (h1Element && svgContainer) {
            svgContainer.classList.remove(
                "single-line",
                "double-line",
                "triple-line"
            );
            h1Element.classList.remove(
                "h1single-line",
                "h1double-line",
                "h1triple-line"
            );

            let height = h1Element.offsetHeight;
            if (height <= 60) {
                svgContainer.classList.add("single-line");
                h1Element.classList.add("h1single-line");
            } else if (height > 60 && height <= 90) {
                svgContainer.classList.add("double-line");
                h1Element.classList.add("h1double-line");
            } else {
                svgContainer.classList.add("triple-line");
                h1Element.classList.add("h1triple-line");
            }
        }
    }

    updateSvgContainerClass();

    window.addEventListener("resize", updateSvgContainerClass);

    let popoverTriggerEl = document.querySelector('[data-bs-toggle="popover"]');
    var boundary = window.matchMedia("(max-width: 768px)").matches ? 'window' : document.querySelector('#ckdisplay');

    if (popoverTriggerEl) {
        let popover = new bootstrap.Popover(popoverTriggerEl, {
            boundary: boundary,
            trigger: "click",
            placement: "bottom",
            html: true,
            fallbackPlacements: [],
        });

        popoverTriggerEl.addEventListener("click", function () {
            popover.toggle();
        });

        document.addEventListener("click", function (event) {
            let targetElement = event.target;

            do {
                if (targetElement == popoverTriggerEl) {
                    return;
                }
                targetElement = targetElement.parentNode;
            } while (targetElement);

            popover.hide();
        });
    } else {
        //console.log("Popover trigger element not found");
    }

});
